
import { TabContent } from '@launchpad/components/pages/Project/ui/ProjectContent';
import { tableOfContentTab } from '@launchpad/data/projects/foxsyai/data';

import type { ProjectContentData } from '../types';
import { PROJECT_CONTENT_TAB_TYPE } from '../types';

export const foxsyai: ProjectContentData = {
  id: 'foxsyai',
  tabs: [
    {
      id: 'description',
      label: 'Description',
      type: PROJECT_CONTENT_TAB_TYPE.CONTENT,
      content: <TabContent items={tableOfContentTab} />,
    },
  ],
  hideTabs: true,
};
